export const queryNames = {
  getTimeSheets: 'getTimeSheets',
  saveHours: 'saveHours',
  submitTimeSheet: 'submitTimeSheet',
  validateTimeSheet: 'validateTimeSheet',
  rejectTimeSheet: 'rejectTimeSheet'
};
